import { Badge } from '@postscript/components';
import {
  sentenceCase,
  verificationTierPresentation,
} from 'components/brand/offers/offerScanPresentation';
import { useProposalAudience } from 'components/brand/offers/proposalAudience';
import {
  ConflictNote,
  MutedText,
} from 'components/brand/offers/proposalStyles';
import {
  ProposalVerification,
  ProposalVerificationTier,
} from 'components/brand/offers/types';
import styled from 'styled-components';

const Section = styled.div`
  display: grid;
  gap: var(--spacing-1);
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
`;

export const ProposalVerificationBadge = ({
  tier,
}: {
  tier?: ProposalVerificationTier | null;
}): JSX.Element => {
  const audience = useProposalAudience();
  const { label, variant } = verificationTierPresentation(tier, audience);

  return (
    <Badge size="small" variant={variant}>
      {label}
    </Badge>
  );
};

export const ProposalVerificationSection = ({
  verification,
}: {
  verification?: ProposalVerification | null;
}): JSX.Element | null => {
  const audience = useProposalAudience();
  if (!verification) return null;
  const { detail, discount, conflicts, discoveryUnavailable } = verification;

  return (
    <Section>
      <SectionHeader>
        <strong>Verification</strong>
        <ProposalVerificationBadge tier={verification.tier} />
      </SectionHeader>
      {detail && <span>{detail}</span>}
      {discount && (
        <span>
          Matched discount: {discount.title} · {sentenceCase(discount.status)}
        </span>
      )}
      {Array.from(new Set(conflicts ?? [])).map((conflict) => (
        <ConflictNote key={conflict}>{conflict}</ConflictNote>
      ))}
      {discoveryUnavailable && audience === 'staff' && (
        <MutedText>
          The Shopify discount check was unavailable for this scan.
        </MutedText>
      )}
    </Section>
  );
};
